module.exports = __webpack_public_path__ + "img/chromeStore.682e2042.png";